// proc_fee_percentage and net_proc_fee_percentage are paired with proc_fee_fixed and net_proc_fee_fixed
// they can be updated dynamically in either direction, this function filters out the passive fields
export const filterPairedProcFeeFields = (dirtyFields: Record<string, any>, values: Record<string, any>) => {
  let invalidFields: string[] = []

  if (values.invalidFieldGross === 'proc_fee_percentage') {
    invalidFields.push('proc_fee_percentage')
  }
  if (values.invalidFieldNet === 'net_proc_fee_percentage') {
    invalidFields.push('net_proc_fee_percentage')
  }
  if (values.invalidFieldGross === 'proc_fee_fixed') {
    invalidFields.push('proc_fee_fixed')
  }
  if (values.invalidFieldNet === 'net_proc_fee_fixed') {
    invalidFields.push('net_proc_fee_fixed')
  }

  // Remove invalid fields from dirtyFields
  return Object.keys(dirtyFields)
    .filter((key) => !invalidFields.includes(key))
    .reduce((acc, key) => ({ ...acc, [key]: dirtyFields[key] }), {}) as Record<string, any>
}
